/* src/app/components/discovery/dialogs/production-job-audit-log/production-job-audit-log.component.scss */
.audit-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin: 12px 16px;
}
.audit-card {
  border: 1px solid #989898;
  background-color: rgba(223, 223, 223, 0.9215686275) !important;
}
.audit-card h3 {
  margin-top: 0;
}
.audit-card p {
  margin: 4px 0;
}
.custom-scroll::-webkit-scrollbar {
  height: 12px;
  width: 15px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background-color: rgb(36, 62, 144);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  background-clip: padding-box;
  -webkit-border-radius: 6px;
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: rgb(36, 62, 144);
}
.custom-scroll::-webkit-scrollbar-corner {
  background: rgba(0, 0, 0, 0.1);
}
:host-context(.dark-theme) .audit-card {
  border: 1px solid #ccc;
  background-color: #4c4c4c !important;
}
:host-context(.dark-theme) .custom-scroll::-webkit-scrollbar {
  height: 12px;
  width: 15px;
}
:host-context(.dark-theme) .custom-scroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}
:host-context(.dark-theme) .custom-scroll::-webkit-scrollbar-thumb {
  background-color: #ffc107;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  background-clip: padding-box;
  -webkit-border-radius: 6px;
}
:host-context(.dark-theme) .custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #f3be1f;
  -webkit-border-radius: 8px;
}
:host-context(.dark-theme) .custom-scroll::-webkit-scrollbar-corner {
  background: #000;
}
:host-context(.dark-theme) .audit-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #1e1e1e;
  color: #ffffff;
}
:host-context(.dark-theme) .audit-table th,
:host-context(.dark-theme) .audit-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #333;
}
:host-context(.dark-theme) .audit-table th {
  background-color: #292929;
  font-weight: bold;
  color: #fff;
}
:host-context(.dark-theme) .audit-table tr {
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}
:host-context(.dark-theme) .audit-table tr:hover {
  background-color: #2a2a2a;
  box-shadow: 0px 2px 4px rgba(255, 255, 255, 0.1);
}
:host-context(.dark-theme) .icon {
  color: #FFC107;
}
.audit-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
  color: #333333;
}
.audit-table th,
.audit-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.audit-table tr {
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}
.audit-table tr:hover {
  background-color: #f5f5f5;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
.audit-table tr:hover td::after {
  width: 100%;
}
.audit-table th {
  background-color: #f4f4f4;
  font-weight: bold;
  border-bottom: 2px solid #ddd;
}
.icon {
  color: #3f51b5;
}
/*# sourceMappingURL=production-job-audit-log.component.css.map */
